/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import templateOnly from '@ember/component/template-only';

interface IArgs {
  type: 'primary' | 'secondary';

  onClick(): void;
}

interface UiButtonSignature {
  Element: HTMLButtonElement;
  Args: IArgs;

  Blocks: {
    default: [];
  };
}

const UiButtonComponent = templateOnly<UiButtonSignature>();

export default UiButtonComponent;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Ui::Button': typeof UiButtonComponent;
  }
}
